module.exports = __webpack_public_path__ + "js/stellarium-web-engine.93c7d1cc.wasm";